import { Navigation, Pagination, Autoplay, Zoom, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useData } from '../../contexts/DataContext';
import { FaBolt, FaCheck, FaClock, FaShieldAlt, FaStar, FaLeaf, FaGraduationCap, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const CoreValuesMobile = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const result = useData();
  const isRTL = language === 'ar';

  const getIconComponent = (iconName) => {
    const icons = {
      'innovation': FaBolt,
      'quality': FaStar,
      'customer': FaCheck,
      'integrity': FaShieldAlt,
      'safety': FaShieldAlt,
      'sustainability': FaLeaf,
      'learning': FaGraduationCap
    };
    const IconComponent = icons[iconName] || FaBolt;
    return <IconComponent className="w-6 h-6" />;
  };
  const about = result.data.about;
  const vision = result.data.vision;
  const mission = result.data.mission;
  const core_values = result.data.core_values;

  return (
    <div className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container px-4 mx-auto">
        <div className="mb-12 text-center">
          <h2 className="mb-4 text-4xl font-bold">{t('coreValues.title')}</h2>
          <div className="mx-auto w-16 h-1 bg-gradient-to-r from-gray-800 to-gray-600 rounded-full"></div>
        </div>

        <div className="relative px-4">
          <Swiper
            modules={[Navigation, Pagination, Autoplay, Zoom, Mousewheel]}
            dir={isRTL ? 'rtl' : 'ltr'}
            navigation={false} // Disable default navigation
            pagination={{
              clickable: true,
              bulletClass: 'swiper-pagination-bullet',
              bulletActiveClass: 'swiper-pagination-bullet-active',
            }}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            keyboard={true}
            mousewheel={{
              enabled: true,
              forceToAxis: true,
              releaseOnEdges: true,
              sensitivity: 2,
            }}
            loop={true}
            spaceBetween={32}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 2 },
              968: { slidesPerView: 3 },
              1280: { slidesPerView: 3 }
            }}
            className="!pb-14 swiper-custom-navigation"
          >
            {core_values.map((value) => (
              <SwiperSlide key={value.id} className="h-auto">
                <div className="group relative h-full p-6 rounded-2xl bg-white border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300">
                  <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                  <div className="relative">
                    <div className="flex items-center mb-4">
                      <div className="p-3 rounded-xl bg-gradient-to-br from-gray-100 to-gray-50 group-hover:from-gray-200 group-hover:to-gray-100 transition-colors duration-300">
                        {getIconComponent(value.icon)}
                      </div>
                      <h3 className="ml-4 text-xl font-semibold text-gray-800">
                        {value.title}
                      </h3>
                    </div>

                    <p className="text-gray-600 leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}

            {/* Custom navigation buttons */}
            <button
              onClick={() => document.querySelector('.swiper-custom-navigation')?.swiper?.slidePrev()}
              className={`absolute top-1/2 -translate-y-1/2 z-10 ${isRTL ? 'right-2' : 'left-2'}
                w-10 h-10 flex items-center justify-center bg-white/90 hover:bg-white shadow-md hover:shadow-lg
                rounded-full transition-all duration-300`}
            >
              {isRTL ?
                <FaChevronRight className="w-4 h-4 text-gray-600" /> :
                <FaChevronLeft className="w-4 h-4 text-gray-600" />
              }
            </button>
            <button
              onClick={() => document.querySelector('.swiper-custom-navigation')?.swiper?.slideNext()}
              className={`absolute top-1/2 -translate-y-1/2 z-10 ${isRTL ? 'left-2' : 'right-2'}
                w-10 h-10 flex items-center justify-center bg-white/90 hover:bg-white shadow-md hover:shadow-lg
                rounded-full transition-all duration-300`}
            >
              {isRTL ?
                <FaChevronLeft className="w-4 h-4 text-gray-600" /> :
                <FaChevronRight className="w-4 h-4 text-gray-600" />
              }
            </button>

            <div className="swiper-pagination !bottom-4"></div>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default CoreValuesMobile;